const CANADIAN_SUBDIVISIONS = [
    { code: "CA-AB", fr: "Canada - Alberta", en: "Canada - Alberta" },
    { code: "CA-BC", fr: "Canada - Colombie-Britannique", en: "Canada - British Columbia" },
    { code: "CA-MB", fr: "Canada - Manitoba", en: "Canada - Manitoba" },
    { code: "CA-NB", fr: "Canada - Nouveau-Brunswick", en: "Canada - New Brunswick" },
    { code: "CA-NL", fr: "Canada - Terre-Neuve-et-Labrador", en: "Canada - Newfoundland and Labrador" },
    { code: "CA-NS", fr: "Canada - Nouvelle-\u00c9cosse", en: "Canada - Nova Scotia" },
    { code: "CA-NT", fr: "Canada - Territoires du Nord-Ouest", en: "Canada - Northwest Territories" },
    { code: "CA-NU", fr: "Canada - Nunavut", en: "Canada - Nunavut" },
    { code: "CA-ON", fr: "Canada - Ontario", en: "Canada - Ontario" },
    { code: "CA-PE", fr: "Canada - \u00cele-du-Prince-\u00c9douard", en: "Canada - Prince Edward Island" },
    { code: "CA-QC", fr: "Canada - Qu\u00e9bec", en: "Canada - Quebec" },
    { code: "CA-SK", fr: "Canada - Saskatchewan", en: "Canada - Saskatchewan" },
    { code: "CA-YT", fr: "Canada - Yukon", en: "Canada - Yukon" },
];

const normalizeLabel = (label) => String(label ?? "").trim().toLowerCase();

export const getCanadianSubdivisionOptions = (locale = "en") =>
    CANADIAN_SUBDIVISIONS.map(({ code, fr, en }) => ({
        value: code,
        label: locale === "fr" ? fr : en,
    }));

export const getJurisdictionOptions = (countryEntries, locale = "en") => [
    ...countryEntries.map(([code, label]) => ({ label, value: code })),
    ...getCanadianSubdivisionOptions(locale),
].sort((a, b) => String(a.label).localeCompare(String(b.label), locale, { sensitivity: "base" }));

export const getJurisdictionLabelToCode = (countryEntries) => {
    const labelToCode = new Map(
        countryEntries.map(([code, label]) => [normalizeLabel(label), code])
    );

    CANADIAN_SUBDIVISIONS.forEach(({ code, fr, en }) => {
        labelToCode.set(normalizeLabel(fr), code);
        labelToCode.set(normalizeLabel(en), code);
    });

    return labelToCode;
};

export const isCanadianSubdivisionCode = (value) =>
    CANADIAN_SUBDIVISIONS.some(({ code }) => code === String(value ?? "").toUpperCase());
